import { render, staticRenderFns } from "./createWebMessageCampaign.vue?vue&type=template&id=c35de69e&"
import script from "./createWebMessageCampaign.vue?vue&type=script&lang=js&"
export * from "./createWebMessageCampaign.vue?vue&type=script&lang=js&"
import style0 from "./createWebMessageCampaign.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports